export default "__VITE_PUBLIC_ASSET__a781bd38__"